import { Grid } from '@mui/material';
import { FC, SetStateAction, Dispatch } from 'react';
import {
  FiltersLayout,
  FiltersButtons,
  SearchField,
  NeighborhoodDropdown,
  TerritoryDropdown
} from '../../../components';

interface IForemenPageFilters {
  isLoading: boolean;
  applyFilters: (clearFilters?: boolean) => void;
  setHasAppliedFilters: Dispatch<SetStateAction<boolean>>;
  hasAppliedFilters: boolean;
  setSearchValue?: (val: string) => void;
  setSearchedValue?: (val: string) => void;
  searchValue?: string;
  handleSearch?: (val: string) => void;
  setSelectedNeighborhoodId?: (val: string | number) => void;
  selectedNeighborhoodId?: string | number;
  setSelectedTerritoryId?: (val: string | number) => void;
  selectedTerritoryId?: string | number;
  searchPlaceholder?: string;
}

export const ForemenPageFilters: FC<IForemenPageFilters> = ({
  isLoading,
  applyFilters,
  setHasAppliedFilters,
  hasAppliedFilters,
  handleSearch,
  searchValue,
  setSearchValue,
  setSearchedValue,
  selectedNeighborhoodId,
  setSelectedNeighborhoodId,
  setSelectedTerritoryId,
  selectedTerritoryId,
  searchPlaceholder
}) => {
  return (
    <FiltersLayout>
      {handleSearch && (
        <Grid item xs={12} sm={6} md={4} xl={3}>
          <SearchField
            isDisabled={isLoading}
            placeholder={searchPlaceholder}
            handleSearch={handleSearch}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />
        </Grid>
      )}
      {setSelectedTerritoryId && (
        <Grid item xs={12} sm={6} md={4} xl={3}>
          <TerritoryDropdown
            isDisabled={isLoading}
            value={selectedTerritoryId}
            handleChange={value => {
              setSelectedTerritoryId(value);
            }}
            handleClear={() => {
              setSelectedTerritoryId('');
            }}
          />
        </Grid>
      )}
      {setSelectedNeighborhoodId && (
        <Grid item xs={12} sm={6} md={4} xl={3}>
          <NeighborhoodDropdown
            isDisabled={isLoading}
            value={selectedNeighborhoodId}
            handleChange={value => {
              setSelectedNeighborhoodId(value);
            }}
            apiParams={{ territoryId: selectedTerritoryId }}
          />
        </Grid>
      )}

      <Grid item xs={12} md={5} xl={3}>
        <FiltersButtons
          hasAppliedFilters={hasAppliedFilters}
          isDisabled={isLoading}
          handleApplyFilters={() => {
            setHasAppliedFilters(true);
            applyFilters();
          }}
          handleResetFilters={() => {
            setHasAppliedFilters(false);
            setSelectedNeighborhoodId && setSelectedNeighborhoodId('');
            setSelectedTerritoryId && setSelectedTerritoryId('');
            setSearchedValue && setSearchedValue('');
            setSearchValue && setSearchValue('');
            applyFilters(true);
          }}
        />
      </Grid>
    </FiltersLayout>
  );
};
